import React from 'react';
import ChatTopicTargetExpansion from '../topics/ChatTopicTargetExpansion';
import '../../../../css/common/chat/ChatTargetListRow.css';

const DEFAULT_CLASS_NAMES = {
  root: 'artist-list-item',
  left: 'artist-item-left',
  center: 'artist-item-center',
  nameLine: 'artist-name-line',
  name: 'artist-name',
  preview: 'artist-last-preview',
  below: 'artist-item-below',
  right: 'artist-item-right',
  time: 'artist-time',
  badge: 'new-message-badge',
};

const joinClassNames = (...tokens) => tokens.filter(Boolean).join(' ');

const ChatTargetListRow = ({
  className = '',
  classNames = {},
  onClick,
  onContextMenu,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  onTouchMove,
  avatar = null,
  left = null,
  center = null,
  right = null,
  title = '',
  titleClassName = '',
  titleExtra = null,
  preview = null,
  previewNode,
  belowContent = null,
  topicScope,
  topicConversationId,
  hasTopics = false,
  onTopicSelect,
  time = null,
  badge = null,
  badgeClassName = '',
  ariaCurrent,
  ariaHidden,
}) => {
  const merged = { ...DEFAULT_CLASS_NAMES, ...(classNames || {}) };
  const hasBelowContent = Boolean(belowContent);
  const hasTopicContent = Boolean(hasTopics && topicConversationId);
  const leftNode = left || (
    <div className={merged.left}>
      {avatar}
    </div>
  );
  const centerNode = center || (
      <div className={merged.center}>
        <div className={merged.nameLine || undefined}>
          <span className={joinClassNames(merged.name, titleClassName)}>{title}</span>
          {titleExtra}
        </div>
      {previewNode !== undefined ? previewNode : (preview != null ? <div className={merged.preview}>{preview}</div> : null)}
    </div>
  );
  const rightNode = right || (
    <div className={merged.right}>
      {time != null ? <span className={merged.time}>{time}</span> : null}
      {badge != null ? <span className={joinClassNames(merged.badge, badgeClassName)}>{badge}</span> : null}
    </div>
  );

  return (
    <li
      className={joinClassNames(merged.root, hasBelowContent ? 'chat-target-list-row--has-below' : '', hasTopicContent ? 'chat-target-list-row--has-topics' : '', className)}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchCancel}
      onTouchMove={onTouchMove}
      aria-current={ariaCurrent}
      aria-hidden={ariaHidden}
    >
      {leftNode}
      {centerNode}
      {rightNode}
      {hasBelowContent ? (
        <div className={joinClassNames(merged.below, 'chat-target-list-row__below')}>{belowContent}</div>
      ) : null}
      {hasTopicContent ? <ChatTopicTargetExpansion scope={topicScope} conversationId={topicConversationId} hasTopics={hasTopics} onSelect={onTopicSelect} /> : null}
    </li>
  );
};

export default ChatTargetListRow;
